import ReactDOM from "react-dom/client";
import { PostHogProvider } from "@posthog/react";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./assets/scss/style.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
const posthogApiKey = "phc_v4tjzw4qj3NPsmBQN3c7kMg4Y6aR57L9Bik2XvZ7ijEh";
const posthogOptions = {
  api_host: "https://eu.i.posthog.com",
  defaults: "2026-01-30",
};

const app = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

root.render(
  <PostHogProvider apiKey={posthogApiKey} options={posthogOptions}>
    {app}
  </PostHogProvider>
);
